import { createFileRoute } from '@tanstack/react-router';
import { CobrancaCartaoPage } from '@/features/cobranca-cartao/page/CobrancaCartaoPage';

export const Route = createFileRoute('/a/cobranca-cartao/')({
    component: CobrancaCartaoPage,
});
